var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 6C14.66 6 16 4.66 16 3C16 1.34 14.66 0 13 0C11.34 0 10 1.34 10 3C10 3.12 10.02 3.24 10.04 3.36L5.08 5.84C4.54 5.32 3.81 5 3 5C1.34 5 0 6.34 0 8C0 9.66 1.34 11 3 11C3.81 11 4.54 10.68 5.08 10.16L10.04 12.64C10.03 12.76 10 12.88 10 13C10 14.66 11.34 16 13 16C14.66 16 16 14.66 16 13C16 11.34 14.66 10 13 10C12.19 10 11.46 10.32 10.92 10.84L5.96001 8.36C5.98001 8.24 6 8.12 6 8C6 7.88 5.98001 7.76 5.96001 7.64L10.92 5.16C11.46 5.68 12.19 6 13 6ZM13 2C13.55 2 14 2.45 14 3C14 3.55 13.55 4 13 4C12.45 4 12 3.55 12 3C12 2.45 12.45 2 13 2ZM3 9C2.45 9 2 8.55 2 8C2 7.45 2.45 7 3 7C3.55 7 4 7.45 4 8C4 8.55 3.55 9 3 9ZM13 12C13.55 12 14 12.45 14 13C14 13.55 13.55 14 13 14C12.45 14 12 13.55 12 13C12 12.45 12.45 12 13 12Z","fill":"#A5AEB6"}));
}

Share.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Share;

Share.default = Share;
